import { put } from 'redux-saga/effects';

import * as endpoint from 'misc/endpoint';
import * as types from 'misc/types';

export function* getTags(action) {
    try {
        const response = yield endpoint.get('tags/');

        response.data.forEach(function(tag) {
            tag.key = tag.id;
        });

        yield put({ type: types.SAGA_TAGS_GET.SUCCESS, payload: response.data });
    } catch (error) {
        yield put({ type: types.SAGA_TAGS_GET.FAILURE, error });
    }
}



// WEBPACK FOOTER //
// ./src/sagas/tags.js